import { css } from "@emotion/react";

import { media } from "./breakpoints";

export const reset = css`
  /* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */
  * {
    font-family: "Inter", sans-serif;
  }
  *:not(.non-reset *) {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  *::before,
  *::after {
    box-sizing: inherit;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }
  a img {
    max-width: 100%;
    height: auto;
  }
  body {
    margin: 0;
    padding: 0px;
    font-size: 13px;
    font-family:
      Arial,
      Microsoft JhengHei;
  }
  html,
  body {
    /* overscroll-behavior-y: none; */
    overscroll-behavior: none;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  input:not(.ant-input),
  select {
    border: 1px solid #dbdbdbff;
    border-radius: 4px;
    ${media.md} {
      border: 0;
    }
  }

  .ant-form-item {
    border-radius: 4px;
    ${media.md} {
      border: 0;
    }
    input {
      outline: none !important;
    }
  }
  .ant-form-item-control-input {
    border: 1px solid #dbdbdbff !important;
  }
  .select {
    .ant-form-item-control-input {
      border: 0 !important;
    }
  }
  ${media.md} {
    * {
      font-size: 14px;
    }
  }

  .center-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .abcxyz {
    inset: 100px auto auto 70.1875px !important ;
  }
`;
